<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-classevaluate__evaluate-ranked">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getPage()">
  
          <!-- <el-form-item>
            <el-button type="primary" @click="exportWeekTimeByAllWeek()">{{ $t('export') }}</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button v-if="$hasPermission('classEvaluate:weekEvaluateProfile:config')" type="primary"
              @click="weekEvaluateProfileConfig()">周评价图表</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button v-if="$hasPermission('classEvaluate:checkRemoveType')" style="color: #0aa0bf"
              @click="removeTypes()">筛选维度</el-button>
          </el-form-item> -->
          <el-form-item label=""  prop="id" style="display: inline-block">
            <el-select v-model="dataForm.termId" placeholder="请选择学期" @change="init">
              <el-option v-for="term in this.termList.list"  :key="term.id" :value="term.id" :label="term.termName"></el-option>
            </el-select>
            <el-form-item>
                    <el-button @click="getSemesteEvaluationReport()">{{ $t('query') }}</el-button>
                </el-form-item>
            <el-form-item>
                    <el-button type="primary" @click="exportSemesteEvaluationReport()">{{ $t('export') }}</el-button>
                </el-form-item>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary">设置周时间</el-button>
          </el-form-item> -->
        </el-form>
  
        <el-table ref="table" v-loading="dataListLoading" :data="dataList" max-height="740px" border
        @selection-change="dataListSelectionChangeHandle" style="width: 100%"
        :default-sort="{ prop: '总分', order: 'null' }">
        
        <el-table-column align="center" :label="currentTerm.deptName + currentTerm.termName + '班级评估表'" class-name="table-top" >
          <el-table-column fixed prop="className" label="班级名称" header-align="center" align="center">
          </el-table-column>
          <el-table-column fixed prop="headTeacherName" label="班主任" header-align="center" align="center">
          </el-table-column>
          <!--   <el-table-column prop="ranked" label="名次" header-align="center" align="center"></el-table-column>-->
          <template v-if="isShowTitle">
          <el-table-column :prop="item.id" v-for="(item, index) in types" :key="index"
            :label="item.examineTypeName" header-align="center" align="center">
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column :prop="item.examineTypeName" v-for="(item, index) in types" :key="index" :label="''"
            header-align="center" align="center">
          </el-table-column>
        </template>
        <el-table-column prop="allTotalScore" label="总分" header-align="center" align="center" sortable></el-table-column>
        </el-table-column>



        <!-- <el-table-column fixed prop="className" label="班级名称" header-align="center" align="center">
        </el-table-column> -->
        <!--   <el-table-column prop="ranked" label="名次" header-align="center" align="center"></el-table-column>-->
        
      </el-table>
        <week-evaluate-profile v-if="weekEvaluateProfileVisible" ref="weekEvaluateProfile"></week-evaluate-profile>
        <remove-type v-if="typeVisible" ref="removeType" @refreshDataList="getDataList"
          v-on:checkedTypes="checkedTypes"></remove-type>
        <weekscore-add v-if="scoreVisible" ref="weekscore" @refreshDataList="getPage"></weekscore-add>
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  import { gradeList } from '@/constant'
  import { addDynamicRoute } from '@/router'
  import WeekEvaluateProfile from './week-evaluate-profile.vue'
  import RemoveType from './remove-type'
  import WeekscoreAdd from './weekscore-add'
  import Template from '../devtools/template'
  import qs from 'qs'
  import Cookies from 'js-cookie'
  // import { Console } from 'console'
  export default {
    components: { Template, WeekscoreAdd, WeekEvaluateProfile, RemoveType },
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/classEvaluate/evaluateScore/week/report',
          getDataListIsPage: false,
          createdIsNeed: false,
          activatedIsNeed: false
        },
        isEnable: '',
        showTypeList: [],
        typeList: [],
        types: [],
        weekTimeList: [],
        itemList: [],
        rollCallDate: [],
        gradeList,
        weekId: '',
        scoreList: [],
        termList: [],
        typeVisible: false,
        discontinuousDates: '',
        Semeste: [],
        dataForm: {
          isEnable: '2',
          startTime: '',
          endTime: '',
          isScore: '',
          evaluateType: '',
          showTypeList: [],
          gradeKey: '',
          weekId: '',
          termId: ''
  
        },
        weekEvaluateProfileVisible: false,
        scoreVisible: false,
        isWeekScore: true,
        isShowTitle: true,
        isCustomTitle: false,
        customTitle: '',
        isExcellentClass: true,
        value: '',
        currentTerm: {},
        timeArr: [
          '2023-2-13 00:00:00,2023-2-17 23:59:59',
          '2023-2-20 00:00:00,2023-2-24 23:59:59',
          '2023-2-27 00:00:00,2023-3-3 23:59:59',
          '2023-3-6 00:00:00,2023-3-10 23:59:59',
          '2023-3-13 00:00:00,2023-3-17 23:59:59',
          '2023-3-20 00:00:00,2023-3-24 23:59:59',
          '2023-3-27 00:00:00,2023-3-31 23:59:59',
          '2023-4-3 00:00:00,2023-4-7 23:59:59',
          '2023-4-10 00:00:00,2023-4-14 23:59:59',
          '2023-4-17 00:00:00,2023-4-21 23:59:59',
          '2023-4-24 00:00:00,2023-4-28 23:59:59',
          '2023-5-1 00:00:00,2023-5-5 23:59:59',
          '2023-5-8 00:00:00,2023-5-12 23:59:59',
          '2023-5-15 00:00:00,2023-5-19 23:59:59',
          '2023-5-22 00:00:00,2023-5-26 23:59:59',
          '2023-5-29 00:00:00,2023-6-2 23:59:59',
          '2023-6-5 00:00:00,2023-6-9 23:59:59',
          '2023-6-12 00:00:00,2023-6-16 23:59:59',
          '2023-6-19 00:00:00,2023-6-23 23:59:59',
          '2023-6-26 00:00:00,2023-6-30 23:59:59'
        ]
      }
    },
    watch: {},
    async mounted () {
      await this.getTypeList2()
      this.getCurrentTerm()
      this.getTerm()
      this.init()
    //   this.getSemesteEvaluationReport()
    },
    computed: {
  
      getEvaluateTypeTitle () {
        let title = '无'
        switch (this.dataForm.evaluateType) {
          case 1:
            title = '“流动红旗”'
            break
          case 2:
            title = '“五星班级”'
            break
          case 3:
            title = '“优胜班级”'
            break
          default:
            title = '无'
            break
        }
        return title
      }
    },
    methods: {
      changeTimeRange (e) {
        console.log(e)
        const index = this.weekTimeList.indexOf(e)
        this.rollCallDate = this.timeArr[index].split(',')
        console.log(index)
      },
      getTerm () {
        this.$http.get('term/term/page').then(({ data: res }) => {
          this.termList = res.data
          console.log(this.termList)
        })
      },
      getCurrentTerm () {
        this.$http.get('/term/term/getCurrentTerm').then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.isEnable = res.data.isEnable
          this.currentTerm = res.data
          this.dataForm.isEnable = 2
        //   this.getSemesteEvaluationReport()
        }).catch(() => { })
      },
      changeUseCalendar () {
        if (this.dataForm.isEnable === 1) {
          this.dataForm.isEnable = 2
          console.log(this.dataForm.isEnable)
        } else if (this.dataForm.isEnable === 2) {
          this.dataForm.isEnable = 1
          console.log(this.dataForm.isEnable)
        }
        this.getPage()
      },
      // 学期优秀班级统计
      getTermGoodClass () {
        this.$nextTick(() => {
          // 路由参数
          const routeParams = {
            routeName: `${this.$route.name}__${this.dataForm.selectTime}`,
            title: '学期优秀班级统计',
            path: 'classevaluate/semester-excellent-class'
  
          }
          // 动态路由
          addDynamicRoute(routeParams, this.$router)
        })
      },
      // 获取信息
      getInfo (id) {
        this.$http.get('/classEvaluate/weekScore/' + id).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          if (res.data != null && res.data.isWeekScore !== 0) {
            this.isWeekScore = false
          } else {
            this.isWeekScore = true
          }
          if (res.data != null && res.data.isShowTitle === 0) {
            console.log(res.data.isShowTitle + '明明就是false')
            this.isShowTitle = false
          } else {
            this.isShowTitle = true
          }
          if (res.data != null && res.data.isCustomTitle === 0) {
            this.isCustomTitle = false
          } else {
            this.isCustomTitle = true
            this.customTitle = res.data.customTitle
          }
          if (res.data != null && res.data.isExcellentClass !== 0) {
            this.isExcellentClass = true
          } else {
            this.isExcellentClass = false
          }
        }).catch(() => { })
      },
      getTypeList2 () {
        console.log('++++')
        return new Promise((resolve) => {
          this.$http
            .post(
              '/classEvaluate/examineType/getExamineTypeList/')
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.types = res.data
  
              this.showTypeList = res.data.filter((i) => {
                return i.isRemoveDimension == 1
              }).map((i) => {
                return i.id
              })
              console.log(this.showTypeList)
  
              this.dataForm.showTypeList = res.data.filter((i) => {
                return i.isRemoveDimension == 1
              }).map((i) => {
                return i.id
              })
              console.log(this.types)
  
              if (this.types.length > 0) {
                this.getInfo(this.types[0].schoolId)
              }
              resolve()
            })
        })
      },
      // 根据班评规则动态查询优秀班级类型
      getTypeBySchoolId () {
        this.$http.get('/classEvaluate/evaluateRule/getRuleBySchoolId').then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          console.log(res.data)
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
        }).catch(() => { })
      },
      getSemesteEvaluationReport () {
        this.$http.get('classEvaluate/evaluateScore/week/getSemesteEvaluationReport',{
            params:{
                termId: this.dataForm.termId,
            }
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          console.log(res.data)
          this.Semeste = res.data
          console.log(this.Semeste)
        }).catch(() => { })
      },
      exportSemesteEvaluationReport() {
        console.log('我进来了')
        console.log(this.dataForm.showTypeList)
        const params = qs.stringify({
          termId: this.dataForm.termId,
          token: Cookies.get('token')
        })
        window.open(`${window.SITE_CONFIG.apiURL}/classEvaluate/evaluateScore/week/exportSemesteEvaluationReport?${params}`)
        // this.$http.get(`/classEvaluate/evaluateRule/week/exportWeekTimeByAllWeekorder=&orderField=&showTypeList=${this.dataForm.showTypeList}&weekId=&isEnable=${this.dataForm.isEnable}&isScore=${this.dataForm.isScore}&termId=${this.dataForm.termId}&gradeKey=&_t=${new Date().getTime()}`).then(({ data: res }) => {
  
        // }).catch(() => { })
      },
      weekStarConfig () {
        this.scoreVisible = true
        this.$nextTick(() => {
          if (this.types.length > 0) {
            this.$refs.weekscore.dataForm.schoolId = this.types[0].schoolId
          }
          this.$refs.weekscore.init()
        })
      },
      removeTypes () {
        this.typeVisible = true
        this.$nextTick(() => {
          this.$refs.removeType.init()
        })
      },
      weekTimeByAllWeek () {
        this.$http
          .get(
            '/classEvaluate/evaluateScore/week/weekTimeByAllWeek')
          .then(({ data: res }) => {
            console.log('星期类型', res)
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
  
            this.weekTimeList = res.data
          })
      },
      checkedTypes (val) {
        console.log(val)
        this.showTypeList = val
        this.dataForm.showTypeList = val
        this.getPage()
      },
      getPage () {
        if (this.rollCallDate !== null) {
          const date = new Date(this.rollCallDate[0])
          this.dataForm.startTime =
            date.getFullYear() +
            '-' +
            (date.getMonth() + 1) +
            '-' +
            date.getDate() +
            ' ' +
            '00:00:00'
          const date2 = new Date(this.rollCallDate[1])
          this.dataForm.endTime =
            date2.getFullYear() +
            '-' +
            (date2.getMonth() + 1) +
            '-' +
            date2.getDate() +
            ' ' +
            '23:59:59'
        } else {
          console.log(222222)
          this.rollCallDate = []
          this.dataForm.startTime = ''
          this.dataForm.endTime = ''
        }
  
        this.init()
      },
      async init () {
        try {
          console.log(2222)
  
          this.getTypeBySchoolId()
          this.weekTimeByAllWeek()
          const dataList = await this.getDateList() // 获取数据列表
          console.log('数据列表', dataList)
          const typeList = await this.getTypeList()
          console.log('类型列表', typeList)
          const itemList = await this.getItemList()
          console.log('检查项列表', itemList)
  
          this.dataList = dataList
        } catch (err) {
          return this.$message.error(err.msg)
        }
      },
      toDecimal (x) {
        var val = Number(x)
        if (!isNaN(parseFloat(val))) {
          val = val.toFixed(2)
        }
        return val
      },
      keepTwoDecimal (num) {
        var result = parseFloat(num)
        if (isNaN(result)) {
          alert('传递参数错误，请检查！')
          return false
        }
        result = Math.round(num * 100) / 100
        return result
      },
      getDateList () {
        const discontinuousDates = []
        if (this.discontinuousDates !== [] && this.discontinuousDates !== null) {
          for (var i = 0; i < this.discontinuousDates.length; i++) {
            const date = new Date(this.discontinuousDates[i])
            const abc = date.getFullYear() +
              '-' +
              (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
              '-' +
              (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
            discontinuousDates.push(abc)
          }
        }
        return new Promise((resolve, reject) => {
          if (this.rollCallDate.length <= 1) {
            this.dataForm.startTime = ''
            this.dataForm.endTime = ''
          } else {
            const date = new Date(this.rollCallDate[0])
            this.dataForm.startTime =
              date.getFullYear() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getDate() +
              ' ' +
              '00:00:00'
            const date2 = new Date(this.rollCallDate[1])
            this.dataForm.endTime =
              date2.getFullYear() +
              '-' +
              (date2.getMonth() + 1) +
              '-' +
              date2.getDate() +
              ' ' +
              '23:59:59'
          }
          this.$http.get(`/classEvaluate/evaluateScore/week/getSemesteEvaluationReport?termId=${this.dataForm.termId}&_t=${new Date().getTime()}`).then(({ data }) => {
            // this.$http.get('/classEvaluate/evaluateScore/week/report', {
            //   params: {
            //     order: '',
            //     orderField: '',
            //     showTypeList: this.dataForm.showTypeList.length > 0 ? JSON.parse(this.dataForm.showTypeList) : '',
            //     isEnable: this.dataForm.isEnable,
            //     isScore: this.dataForm.isScore,
            //     startTime: this.dataForm.startTime,
            //     endTime: this.dataForm.endTime,
            //     gradeKey: '',
            //     discontinuousDates: discontinuousDates
            //   }
            // }).then(({ data }) => {
            if (data.code !== 0) {
              reject({
                msg: data.msg,
                data: data
              })
              return
            }
            const list = data.data
            resolve(list)
          })
            .catch((err) => {
              reject({
                msg: '数据列表获取失败',
                data: err
              })
            })
        })
        this.$refs.table.doLayout()
      },
      getTypeList () {
        return new Promise((resolve, reject) => {
          this.$http
            .post('classEvaluate/examineType/getShowNameList', this.showTypeList)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                reject({
                  msg: res.msg,
                  data: res
                })
                return
              }
              this.typeList = res.data
              resolve(res.data)
            })
            .catch((err) => {
              reject({
                msg: '获取列表类型失败',
                data: err
              })
            })
        })
      },
      getItemList () {
        return new Promise((resolve, reject) => {
          this.$http
            .post('classEvaluate/examineType/getShowTypeList', this.showTypeList)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                reject({
                  msg: res.msg,
                  data: data
                })
                return
              }
              this.itemList = res.data
              resolve(res.data)
            })
            .catch((err) => {
              reject({
                msg: '获取检查项列表失败',
                data: err
              })
            })
        })
      },
      formatJson (filterVal, jsonData) {
        return jsonData.map((v) => {
          return filterVal.map((j) => v[j])
        })
      },
  
      weekEvaluateProfileConfig () {
        this.weekEvaluateProfileVisible = true
        this.$nextTick(() => {
          console.log(this.dataForm)
          /* this.$refs.weekEvaluateProfile.dataForm.startTime = this.dataForm.startTime
          this.$refs.weekEvaluateProfile.dataForm.endTime = this.dataForm.endTime
          this.$refs.weekEvaluateProfile.rollCallDate = this.rollCallDate */
          this.$refs.weekEvaluateProfile.init()
        })
      }
    }
  }
  </script>
  <style scoped>
  /* body .el-table th.gutter {
          display: table-cell!important;
      }*/
  </style>
  